import { EditOutlined } from '@ant-design/icons'
import { Spin } from 'antd'
import React from 'react'
import { generatePath, useNavigate, useParams } from 'react-router-dom'

import Breadcrumb from 'component/breadcrumb/breadcrumb'
import ProtectedButton from 'component/button/protected-button'
import { BREADCRUMBS } from 'constants/breadcrumb'
import { FEATURE } from 'constants/feature'
import { useFaqArticleDetail } from 'hooks/faq'
import { buildArticleBreadcrumb, FaqArticleDetailView, FaqArticleLoadError } from 'modules/faq'
import { PAGES } from 'routes'

import '../style.scss'

const FaqArticleDetailPage: React.FC = () => {
  const { id = '' } = useParams<{ id: string }>()
  const navigate = useNavigate()
  const { data: article, isLoading, error, refetch } = useFaqArticleDetail(id)

  const breadcrumbItems = article
    ? [BREADCRUMBS.FAQ, buildArticleBreadcrumb(article.title)]
    : [BREADCRUMBS.FAQ]

  return (
    <div className="main-section faq-management-page faq-article-page">
      <Breadcrumb additionalItems={breadcrumbItems} onNavigate={navigate} />
      <div className="faq-article-header">
        <div className="main-title">Article Details</div>
        {article ? (
          <ProtectedButton
            type="primary"
            icon={<EditOutlined />}
            feature={FEATURE.FAQ_CREATE}
            requireCRUD
            // view and edit modes share one history entry
            onClick={() =>
              navigate(generatePath(PAGES.FAQ_ARTICLE_EDIT, { id }), { replace: true })
            }
          >
            Edit
          </ProtectedButton>
        ) : null}
      </div>

      {isLoading ? (
        <div className="faq-article-loading">
          <Spin />
        </div>
      ) : article ? (
        <FaqArticleDetailView article={article} />
      ) : (
        <FaqArticleLoadError
          error={error}
          onBack={() => navigate(PAGES.FAQ)}
          onRetry={() => void refetch()}
        />
      )}
    </div>
  )
}

export default FaqArticleDetailPage
